import { submitVehicleClamping } from "../../../hooks/submission/useSubmission";
import {
  useVehicleClamping,
  useVehicleClampingForm,
} from "../../../hooks/vehicle_clamping/useVehicleClamping";
import { API_VEHICLE_CLAMPINGS_PAGINATED } from "../../../utils/apis";
import { CLAMPING } from "../../../utils/constants";

export const clampingRegisterRoutes = {
  clamping: useVehicleClamping,
};

export const clampingFormRoutes = {
  clamping: useVehicleClampingForm,
};

export const clampingFormSubmit = {
  clamping: submitVehicleClamping,
};

export const clampingApis = {
  clamping: API_VEHICLE_CLAMPINGS_PAGINATED,
};

export function getClampingDataApi(type: any) {
  const typeMapping = {
    [CLAMPING]: API_VEHICLE_CLAMPINGS_PAGINATED,
  };

  return typeMapping[type];
}
